import { useState, useEffect,useContext } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import NominaContext from "../context/NominProvider";
const Layout = ({ Auth }) => {
  
  // const [selectedNomina, setSelectedNomina] = useState(() => {
  //   const saved = localStorage.getItem("selectedNomina");
  //   return saved ? JSON.parse(saved) : null;
  // });

    const { selectedNomina, setSelectedNomina } = useContext(NominaContext);

  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);

  // useEffect(() => {
  //   if (selectedNomina !== null) {
  //     localStorage.setItem("selectedNomina", JSON.stringify(selectedNomina));
  //   } else {
  //     localStorage.removeItem("selectedNomina");
  //   }
  // }, [selectedNomina]);

  return (
    <div className="layout-container">
      <div className="navbar">
        <Navbar
          Auth={Auth}
          selectedNomina={selectedNomina}
          setSelectedNomina={setSelectedNomina}
        />
      </div>
      <div className="main-content">
        <Outlet
          context={{
            selectedNomina,
            empleadoSeleccionado,
            setEmpleadoSeleccionado,
          }}
        />
      </div>
    </div>
  );
};

export default Layout;
